import React, { useEffect, useState } from 'react'
import ListGroup from '../../userPages/partials/ListGroup'
import UserHero from '../../userPages/partials/UserHero'
import { CiCirclePlus } from "react-icons/ci";
import { Link } from 'react-router-dom';
import { MdDeleteForever } from "react-icons/md";
import { FaFrownOpen } from "react-icons/fa";
import { CiEdit } from "react-icons/ci";
import toast from 'react-hot-toast';

export default function AdminGallery() {
    let [data,setData] = useState([])



async function deleteData(_id) {
   if(window.confirm("Are You Sure to Delete that Item :")){
    let response = await fetch(`http://34.228.14.188:8000/api/gallery/`+ _id,{
        method:"DELETE",
        headers:{
            "content-type" : "application/json"
        },
    })
    response = await response.json()
    if(response.result==="Done"){
       toast.success("Deleted Successfully");
          getApiData();
    }
     else {
          toast.error("Failed to delete!");
        }
   }
}



async function getApiData() {
    let response = await fetch( "http://34.228.14.188:8000/api/gallery" , {
           method :"GET",
           headers:{
            "content-type":"application/json",
            // "authorization":localStorage.getItem("token")
                  }
    })

    response = await response.json()
    
    if(response.result = "Done"){
        setData(response.data)
      
    }
}



useEffect(()=>{
    getApiData()
} ,[data?.length])
  return (
    <>
    <UserHero/>
       <div className="container">
       






                <div className="row my-3">
                 
                   <ListGroup/>
                  
                  <div className="col-md-8">
         <h1 className=' testimonials-h1 text-light text-center p-2' style={{background:"#"}}>Gallery Table <Link to="/admin/create-gallery"> <CiCirclePlus className='float-end text-light' /> </Link></h1>
         <div className="table-responsive">
             {
                data.length?

                <table className='table table-bordered responsive'>
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Room  Name</th>
                        <th>Room Pic</th>
                      
                        <th>Edit</th>
                        
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        data.map((item,index)=>{
                            return <tr key={index}>
                                <td>{item._id}</td>
                                <td>{item.name}</td>
                                    
                                  <td>
                          <div style={{width:200}}>
                          {
                             item.pic.map((img,index)=>{
                              return <Link key={index} to={`${img}`} target="blank" rel="noreferrer">
                                <img src={`http://34.228.14.188:8000${img}`} height={50} width={50} className='me-1' alt="Product image" />
                              </Link>
                             })

                        
                           }
                          </div>
                         
                        
                        </td>
                               

                                <td>
                                    <Link to={`/admin/update-gallery/${item._id}`}>
                                   <CiEdit   className='testimonil-table-btn' style={{height:"30", width:"50",color:"blue" }} />
                                   </Link>     
                                </td>

                                <td>
                               
                                <MdDeleteForever className='testimonil-table-btn' style={{height:"30", width:"50", }} onClick={() => deleteData(item._id)} />
                            
                                </td>

                            </tr>
                        })
                    }
                </tbody>
              </table>
              :
              <div className="not-testinomonil">
                <h3>Sorry! <FaFrownOpen />  Gallery  Record Not Found!!</h3>
                
              </div>
             }
            
                  </div>
              </div>
              </div>
       </div>
    </>
  )
}
